// import { createSelector } from 'reselect'; // koristicemo kasnije, za sada samo podsetnik

export const selectCeoState = (state) => state;
export const selectAppState = (state) => state.app;
export const selectDraft = (state) => state.draft;

export const selectAuthInitialAutoLoginCompleted = (state) => selectAppState(state).authInitialAutologinCompleted;
export const selectAuthLoginFetching = (state) => selectAppState(state).authLoginFetching;

export const selectUser = (state) => selectAppState(state).user;
export const selectUlogovan = (state) => selectAppState(state).user.ulogovan;
export const selectRole = (state) => selectAppState(state).user.role;
export const selectUsername = (state) => selectAppState(state).user.username;
export const selectUserId = (state) => selectAppState(state).user.id;

export const selectRouteSimple = (state) => selectAppState(state).routeSimple;

export const selectUserList = (state) => selectAppState(state).userList;

export const selectclickedKomoraSubkey = (state) => selectAppState(state).clickedKomoraSubkey;
export const selectClickedModulSubkey = (state) => selectAppState(state).clickedModulSubkey;

export const selectSpinnerGlobal = (state) => selectAppState(state).spinnerGlobal;
// export const selectToasts = (state) => selectAppState(state).toasts;
export const selectObavestenja = (state) => selectAppState(state).obavestenja;
export const selectToasts = (state) => {
  let onlyNewToasts = selectAppState(state).obavestenja.filter((toast) => {
    if (toast.closed === true) {
      return false; // ako je obavestenje closed to znaci da je vec bilo prikazano u obliku animiranog toast-a i ne prikazjemo ga opet kao toas (ali ostaje u obavestenjima)
    }
    return true;
  });
  return onlyNewToasts;
}
export const selectModal = (state) => selectAppState(state).modal;
export const selectSecondScreen = (state) => selectAppState(state).secondScreen;

export const selectOpstiPodaci = (state) => selectAppState(state).opstiPodaci;

// TER termovent specificne
export const selectSuperValidacija = (state) => selectDraft(state).superValidacija;
export const selectDraftFreshness = (state) => selectDraft(state).freshness;
export const selectDraftSaved = (state) => selectDraft(state).saved;
export const selectDraftLoaded = (state) => selectDraft(state).loaded;
export const selectDraftSaving = (state) => selectDraft(state).saving;
export const selectDraftLoading = (state) => selectDraft(state).loading;
export const selectDraftVirbomHeader = (state) => selectDraft(state).virbom_header;
export const selectDraftVirbomHeaderDb = (state) => selectDraft(state).virbom_header_db;
export const selectDraftVirbomSeq = (state) => selectDraft(state).virbom_seq;
export const selectDraftSmartbom = (state) => selectDraft(state).smartbom;
export const selectDraftSastavnicaInternal = (state) => selectDraft(state).sastavnica_internal;

export const selectWizardInfo = (state) => selectDraft(state).wizardInfo;
export const selectReducerResponses = (state) => selectDraft(state).reducerResponses;

export const selectComorderList = (state) => selectAppState(state).comorderList;
export const selectComorderCurrent = (state) => selectAppState(state).comorderCurrent;
export const selectComorditemList = (state) => selectAppState(state).comorditemList;
export const selectComorditemCurrent = (state) => selectAppState(state).comorditemCurrent;
export const selectComorditemCreatedId = (state) => selectAppState(state).comorditemCreatedEntityId;
export const selectPpGenusList = (state) => selectAppState(state).ppGenusList;

export const selectExternalFiles = (state) => selectAppState(state).externalFiles;

export const selectDevDbWhole = (state) => selectAppState(state)._dev_db_whole;